export const isSupportedBrowser = (): boolean => {
	const ua = navigator.userAgent;

	const isChrome = /Chrome/.test(ua) && /Google Inc/.test(navigator.vendor) && !/Edg|OPR/.test(ua);

	const isFirefox = /Firefox/.test(ua);

	return isChrome || isFirefox;
};
